// extracted by mini-css-extract-plugin
export var downArrow = "_8m-0";
export var label = "_8m-1";
export var treatmentCard = "_8m-3";
export var upArrow = "_8m-2";